<template>
  <div
    :meta-error="metaError"
    :class="['input-component w-full relative', extraClass, isActive ? 'is-active' : '', error ? 'is-error' : '']"
  >
    <div class="relative input">
      <input
        v-model="inputValue"
        :placeholder="placeholder"
        :name="name"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :aria-label="label"
        type="text"
        class="w-full text-black h-12.5 border border-sw_gray-300 rounded-none placeholder-sw_yellow_error-text text-base px-4 appearance-none outline-none"
        :class="[inputClass]"
        @focus="onFocus"
        @blur="onBlur"
        @paste="onPaste"
        @change="onChange"
      >
      <span
        v-if="optional"
        class="absolute top-0 bottom-0 right-0 flex items-center mr-3 text-xs leading-none text-gray-600 optional"
      >
        {{ tr('components.flightVoucher.form.optional') }}
      </span>
    </div>

    <p v-if="error">
      <span class="block px-2 py-1 mt-1 text-xs leading-none bg-sw_red-100 text-sw_text">{{ error }}</span>
    </p>
  </div>
</template>

<script>
import TextInput from '~components/shared/text-input'

export default TextInput.extend({})
</script>

<style lang="scss" scoped>
  .input-component {
    &.is-error {
      .input {
        input {
          @apply border-sw_error;
        }
      }
    }

    &.is-optional {
      input {
        padding-right: 75px; /* let's assume that word "optional" has that width in all translations */
      }
    }
  }

  .uppercase.placeholder-normal-case {
    &::-webkit-input-placeholder {
      /* WebKit browsers */
      text-transform: none;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      text-transform: none;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      text-transform: none;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      text-transform: none;
    }

    &::placeholder {
      /* Recent browsers */
      text-transform: none;
    }
  }
</style>
